import gHlp from '../assets/js/global-files/globalHelper'
import gAuth from '../assets/js/global-files/globalAuth'
import gNotif from '../assets/js/global-files/globalNotification'
import gFile from '../assets/js/global-files/globalFile'

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalMethods = {
  install(Vue) {
		window._gHlp = gHlp();
		window._gAuth = gAuth();
		window._gNotif = gNotif();
		window._gFile = gFile();
		
    Vue.prototype._gHlp = gHlp();
		Vue.prototype._gAuth = gAuth();
		Vue.prototype._gNotif = gNotif();
		Vue.prototype._gFile = gFile();
  }
};

export default GlobalMethods;
